import React from "react";

import { dateFormatter } from "../../../utils/DataGrid/dateFormatter";

import DataGridTablePage from "../../../Components/DataGridTablePage/DataGridTablePage";
import { useLocation } from "react-router-dom";

const fieldHeaderPairs = [
  { field: "HIST_ID" },
  { field: "STORE_CODE", headerName: "Branch" },
  { field: "STOCK_CODE", headerName: "Style" },
  {
    field: "SOH_DATE",
    headerName: "SOH Date",
    valueFormatter: (params) => dateFormatter(params),
  },
  { field: "SOH", headerName: "SOH" },
  // { field: "CUSTOMER_ID", headerName: "Customer Name" },
];

const filterColumn = [
  {
    field: "STORE_CODE",
    label: "Branch",
    component: "AutocompleteField",
    url: "/replenishment/soh-history",
    overrideDataField: "branchList",
  },
  {
    field: "STOCK_CODE",
    label: "Style",
    component: "TextField",
  },
  {
    field: "sohGreater",
    label: "SOH Greater Than",
    component: "TextField",
    type: "number",
  },
  {
    field: "sohLess",
    label: "SOH Less Than",
    component: "TextField",
    type: "number",
  },
  {
    field: "startDate",
    label: "Start Date",
    component: "TextField",
    type: "date",
  },
  {
    field: "endDate",
    label: "End Date",
    component: "TextField",
    type: "date",
  },
  // {
  //   field: "soldToa",
  //   // label: "Sold To",
  //   component: "AutocompleteField",
  //   url: "/current/company-account/all",
  // },
];

const ReplenishmentHistorySOH = () => {
  const location = useLocation();

  return (
    <DataGridTablePage
      hideMenu={1}
      headerTitle="List SOH History"
      exportFeature={true}
      navigateState={location.state}
      customIDKey="HIST_ID"
      columns={fieldHeaderPairs}
      filterColumn={filterColumn}
      // children={<Test />}
      pageUrl="/replenishment/soh-history"
      columnsVisibility={{
        HIST_ID: false,
      }}
    />
  );
};

export default ReplenishmentHistorySOH;
